import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs'
import { bankActions } from '../../redux/actions/bankActions';
import CreateTab from './CreateTab';
import MainTab from './MainTab'
import UpdateTab from './UpdateTab';

const BankPage = () => {
  const dispatch = useDispatch();
  const { activeTabKey, tabs } = useSelector(state => state.banks);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(bankActions.changeTab(key))}
      >
        <Tab title="Bank">
          <MainTab />
        </Tab>
        <Tab title="Buat">
          <CreateTab />
        </Tab>
        {tabs.map((row, key) =>
          <Tab
            key={row.key}
            title={row.title}
            isLoading={row.loading}
            onClose={() => dispatch(bankActions.closeTab(row.key))}
            onClick={() => dispatch(bankActions.changeTab(row.key))}
            active={activeTabKey === row.key}
          >
            <UpdateTab index={key} />
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default BankPage

